import { DocumentNode } from 'graphql'
import { computed, makeObservable } from 'mobx'

import {
  DeleteDeliveryUnitsDocument,
  GetDeliveryUnitsDocument,
  ListenToDeliveryUnitsDocument,
  SaveDeliveryUnitsDocument,
} from '~/client/graph/operations/generated/DelliveryUnits.generated'

import CommonDeliveryAttributeDto from '../../types/CommonDeliveryAttributeDto'
import EventsStore from '../EventStore/Events.store'
import CommonDeliveryAttributesStore from './CommonDeliveryAttributes.store'
import GraphExecutorStore from './GraphExecutor.store'

export default class DeliveryUnitsStore extends CommonDeliveryAttributesStore {
  protected readonly collectionKey: string = 'deliveryUnits'

  protected readonly loadQuery: DocumentNode = GetDeliveryUnitsDocument
  protected readonly subscriptionQuery: DocumentNode =
    ListenToDeliveryUnitsDocument
  protected readonly saveMutation: DocumentNode = SaveDeliveryUnitsDocument
  protected readonly deleteMutation: DocumentNode = DeleteDeliveryUnitsDocument

  public constructor(
    eventsStore: EventsStore,
    graphExecutorStore: GraphExecutorStore,
  ) {
    super(eventsStore, graphExecutorStore)

    makeObservable(this)
  }

  @computed
  public get list(): CommonDeliveryAttributeDto[] {
    return Array.from(this.byId.values()).filter(
      entry => !entry.isDeleted && !entry.isFromConcreteDirect,
    )
  }

  public get byId(): Map<string, CommonDeliveryAttributeDto> {
    return this.eventsStore.appState.deliveryUnits
  }
}
